import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { Client } from 'src/app/models/client.model';
import { Clinic } from 'src/app/models/clinic.model';
import { Module } from 'src/app/models/module.model';
import { User } from 'src/app/models/user.model';
import { ClientsService } from 'src/app/services/clients.service';
import { ClinicService } from 'src/app/services/clinic.service';
import { ModalCreateClientService } from 'src/app/services/modal-create-client.service';
import { ModuleService } from 'src/app/services/module.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-create-client',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './modal-create-client.component.html',
  styleUrl: './modal-create-client.component.scss'
})
export class ModalCreateClientComponent {
  @Input() isNew: boolean = true;
  @Input() isView: boolean = false;
  public createClientForm: FormGroup;
  public createClinicForm: FormGroup
  user: User

  newClinic: Clinic = {
    ID: '',
    clientID: '',
    name: '',
    connectedPlatform: {
      name: '',
      identifier: '',
      identifiersList: []
    },
    shippingAddress: {
      userId: '',
      contactNameAndSurname: '',
      country: '',
      city: '',
      province: '',
      streetNameAndNumber: '',
      apartmentOrOthers: '',
      postalCode: '',
      phoneNumber: '',
      default: false,
      vat: ''
    },
    billingAddress: {
      userId: '',
      contactNameAndSurname: '',
      country: '',
      city: '',
      province: '',
      streetNameAndNumber: '',
      apartmentOrOthers: '',
      postalCode: '',
      phoneNumber: '',
      default: false,
      vat: ''
    },
    default: false
  }

  constructor(
    private formBuilder: FormBuilder,
    public modalCreateClientService: ModalCreateClientService,
    public moduleService: ModuleService,
    private clientService: ClientsService,
    private clinicService: ClinicService,
    public userService: UserService
  ) {
    this.createClientForm = this.formBuilder.group({
      ID: [''],
      name: ['', [Validators.required, Validators.minLength(1)]],
      email: ['', [Validators.required, Validators.email]],
      // moduleID: ['0', [Validators.required, Validators.minLength(2)]],
      description: ['']
    })

    this.createClinicForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(1)]],
      default: [false, { nonNullable: true }],
      connectedPlatform: this.formBuilder.group({
        name: [''],
        identifier: [''],
        identifiersList: ['']
      }),
      shippingAddress: this.formBuilder.group({
        contactNameAndSurname: ['', [Validators.required, Validators.minLength(1)]],
        country: ['', [Validators.required, Validators.minLength(1)]],
        city: ['', [Validators.required, Validators.minLength(1)]],
        province: [''],
        streetNameAndNumber: [''],
        apartmentOrOthers: [''],
        postalCode: [''],
        phoneNumber: ['']
      }),
      billingAddress: this.formBuilder.group({
        contactNameAndSurname: ['', [Validators.required, Validators.minLength(1)]],
        country: ['', [Validators.required, Validators.minLength(1)]],
        city: ['', [Validators.required, Validators.minLength(1)]],
        province: [''],
        streetNameAndNumber: [''],
        apartmentOrOthers: [''],
        postalCode: [''],
        phoneNumber: ['']
      })
    });

    this.user = userService.user
  }

  @Input() model: Client;
  modules: Module[] = []
  public viewclientDetail: Client | undefined;

  ngOnInit(): void {
  }

  createClient() {
    this.isNew = true;

    if (this.createClinicForm.invalid) {
      this.createClinicForm.markAllAsTouched();
      return;
    }

    if (this.createClientForm.valid && this.createClinicForm.valid) {
      this.modalCreateClientService.closeModal()
      Swal.fire({
        title: '正在创建客户端……',
        text: '请等待我们在系统中创建该客户。'
      })
      Swal.showLoading();

      // this.clientService.createUserOnFireBase(this.createClientForm.value).subscribe(
      //   () => {
      //   },
      //   (error) => {
      //     Swal.fire('Error', error.message, 'error')
      //   }
      // )

      console.log("createClientForm.value: ", this.createClientForm.value)

      this.clientService.create(this.createClientForm.value).subscribe(
        () => {

          const { email } = this.createClientForm.value
          this.clientService.getClient(email).subscribe({
            next: (client) => {
              const clientId = client.ID

              const {
                name,
                connectedPlatform: {
                  identifier: connectedPlatformIdentifier
                },
                shippingAddress: {
                  contactNameAndSurname: shippingContactName,
                  country: shippingCountry,
                  city: shippingCity,
                  streetNameAndNumber: shippingStreet,
                  apartmentOrOthers: shippingApartment,
                  postalCode: shippingPostalCode,
                  province: shippingProvince,
                  phoneNumber: shippingPhoneNumber,
                },
                billingAddress: {
                  contactNameAndSurname: billingContactName,
                  country: billingCountry,
                  city: billingCity,
                  streetNameAndNumber: billingStreet,
                  apartmentOrOthers: billingApartment,
                  postalCode: billingPostalCode,
                  province: billingProvince,
                  phoneNumber: billingPhoneNumber,
                }
              } = this.createClinicForm.value;



              const clinicData = {
                clientID: clientId,
                name,
                default: true,
                connectedPlatform: {
                  name: "Edser",
                  identifier: connectedPlatformIdentifier,
                  identifiersList: this.newClinic.connectedPlatform.identifiersList
                },
                shippingAddress: {
                  contactNameAndSurname: shippingContactName,
                  country: shippingCountry,
                  city: shippingCity,
                  streetNameAndNumber: shippingStreet,
                  apartmentOrOthers: shippingApartment,
                  postalCode: shippingPostalCode,
                  province: shippingProvince,
                  phoneNumber: shippingPhoneNumber,
                  default: true
                },
                billingAddress: {
                  contactNameAndSurname: billingContactName,
                  country: billingCountry,
                  city: billingCity,
                  streetNameAndNumber: billingStreet,
                  apartmentOrOthers: billingApartment,
                  postalCode: billingPostalCode,
                  province: billingProvince,
                  phoneNumber: billingPhoneNumber,
                  default: true
                }
              };

              this.clinicService.createClinic(clinicData as Clinic).subscribe({
                next: (response) => {

                  let clientToUpdate = client

                  clientToUpdate.identifier = connectedPlatformIdentifier
                  clientToUpdate.identifiersList = this.newClinic.connectedPlatform.identifiersList

                  this.clientService.updateIdentifier(clientToUpdate).subscribe({
                    next: (response) => {
                      console.log("Client identifier updated")

                      this.clientService.updateIdentifiersList(clientToUpdate).subscribe({
                        next: (response) => {
                          console.log("Client identifiers list updated")

                          this.modalCreateClientService.closeModal();
                          Swal.fire('已创建！', '客户创建成功！', 'success');
                          this.createClientForm.reset();
                          this.modalCreateClientService.newClientCreated.emit('client_created');
                        },
                        error: (err) => {
                          Swal.fire('客户端标识符列表更新失败', err.message, 'error');
                        },
                      })
                    },
                    error: (err) => {
                      Swal.fire('客户端标识符更新失败', err.message, 'error');
                    },
                  })
                },
                error: (err) => {
                  Swal.fire('诊所创建失败', err.message, 'error');
                },
              })
            },
            error: () => {
              console.error("Error getting client")
            }
          })
        },
        (error) => {
          Swal.fire('Error', error.error.message, 'error')
        }
      )
    } else {
      Swal.fire('Error', '表单无效，请检查各项值。', 'warning');
    }
    // let setClientId = localStorage.setItem('clientId',ID)
  }

  updateNewClinicMultipleIdentifiers() {
    this.newClinic.connectedPlatform.identifiersList = this.createClinicForm.get('connectedPlatform.identifiersList').value;
  }

  copyShippingAddress(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.createClinicForm.get('billingAddress').setValue(this.createClinicForm.get('shippingAddress').value);
    } else {
      this.createClinicForm.get('billingAddress').reset();
    }
  }

  closeModal() {
    this.createClientForm.reset()
    this.createClinicForm.reset()
    this.modalCreateClientService.closeModal()
  }

  viewClient() {
    this.isView = true;
  }
  editClient() {
    this.isNew = false;
  }
}
